import React, { useEffect, useState } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { AxiosResponse, HttpStatusCode } from 'axios';
import { useApi } from '../../../../context/ApiProvider';
import { useAlertContext } from '../../../../context/AlertProvider';
import { AnnouncementInterface } from '../../../../shared/type/message.type';
import IconComponent from '../../../IconComponent/IconComponent';
import { useUnreadThreadCountContext } from '../../../../context/UnreadMessageContext';

export const SingleAnnouncement = () => {
  const { apiTenantAnnouncementController } = useApi();
  const { threadId: announcementId } = useParams();
  const { setShow, setAlertProperties } = useAlertContext();
  const [announcement, setAnnouncement] = useState<AnnouncementInterface | undefined>();
  const { decrementUnreadThreadCount } = useUnreadThreadCountContext();

  const location = useLocation();
  const basePath = location.pathname.split('/').slice(0, -2).join('/');

  const fetchAnnouncement = async () => {
    try {
      const response: AxiosResponse<AnnouncementInterface> = await apiTenantAnnouncementController(
        'details'
      ).get('', {
        params: {
          announcementId
        }
      });

      if (response.status !== HttpStatusCode.Ok) {
        return;
      }

      setAnnouncement(response.data);
    } catch (error) {
      setAlertProperties({
        status: 'error',
        timeout: 9000,
        description: 'Błąd pobierania wiadomości',
        title: 'Błąd'
      });
      setShow(true);
    }
  };

  useEffect(() => {
    fetchAnnouncement();
  }, []);

  useEffect(() => {
    decrementUnreadThreadCount();
  }, []);

  return (
    <section className="flex flex-col h-full gap-spacing-xl w-full pb-20">
      <div className="pt-spacing-md pr-spacing-3xl pb-spacing-md pl-spacing-3xl gap-spacing-md">
        <Link
          to={`${basePath}/announcement`}
          className="flex items-center gap-spacing-sm pt-2.5 pr-spacing-xl pb-2.5 pl-spacing-xl">
          <IconComponent iconName="arrowLeft" />
          <p style={{ fontSize: '16px' }} className="font-semibold text-grayWarm-950">
            Wróć
          </p>
        </Link>
        <h2 className="text-2xl font-semibold text-grayLight-900">
          Komunikat dla: {announcement?.consumerNames?.join(', ') || announcement?.topic}
        </h2>
      </div>

      {announcement && (
        <div className="pr-spacing-3xl pl-spacing-3xl flex-grow overflow-y-auto">
          <p className="text-sm font-semibold text-grayLight-700 mb-spacing-sm">
            {announcement?.sendingUser.firstName} {announcement?.sendingUser.lastName}
          </p>
          <div className="min-h-spacing-11xl p-spacing-xl bg-white border border-gray-200">
            {announcement?.content}
          </div>
        </div>
      )}
    </section>
  );
};
